import { connect } from 'react-redux'
import { ChatBot } from '../../components'

const mapStateToProps = (state, { push }: any) => ({
  messages: ['Terminate Lease'],
  title: 'Termination',
  description:
    'Enter the details for the early termination of this lease. The lease will be terminated immediately. Future recurring invoices will be disabled, however you can still create ad hoc invoices, credit notes and process payments against this lease.',
  actions: [],
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
